import { Text } from '@/components/shared/Text/Text';

export const UserProfileInfo = ({
  title,
  value,
}: {
  title: string;
  value: string | React.ReactNode;
}) => (
  <div className="pt-4 mt-4 grid grid-cols-4 gap-4">
    <div className="col-span-1 font-semibold">
      <Text.Normal>{title}:</Text.Normal>
    </div>
    <div className="col-span-3 items-center">
      {typeof value === 'string' ? <Text.Normal>{value}</Text.Normal> : value}
    </div>
  </div>
);
